import {
  Component,
  forwardRef,
} from '@angular/core';
import {
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { ClientWrapperComponent } from '@app/pages/quote/standard-quote/client/client-wrapper.component';
import { MenusServices } from '@app/services/menus.service';
import { NotificationService } from '@app/services/notifications.service';


@Component({
  selector: 'app-client-desktop',
  templateUrl: './client-desktop.component.html',
  styleUrls: ['./client-desktop.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ClientDesktopComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => ClientDesktopComponent),
      multi: true,
    },
  ],
})
export class ClientDesktopComponent extends ClientWrapperComponent
{
  constructor(
    route: ActivatedRoute,
    menu: MenusServices,
    notification: NotificationService
  ) {
    super(route, menu, notification);
  }
}

